import React, { PropsWithoutRef } from 'react';
import styled, { css } from 'styled-components';
import { MICHIGAN_GOV_WEBSITE_URL } from '../../config/index';

const StyledImg = styled.img`
  cursor: pointer;
  display: flex;
  ${(props) => css`
    height: ${props.height};
  `};
`;

const getImagePath = (props: any) => `/images/logo/michigan_logo.png`;

type LogoProps = {
  className?: string;
  height?: number;
  handleLogoOnClick?: (...args: any[]) => any;
  style?: any;
  showGreyLogo?: boolean;
};

const MichiganLogo = (props: PropsWithoutRef<LogoProps>) => {
  const { className, handleLogoOnClick, height } = props;
  return (
    <>
      {handleLogoOnClick ? (
        <div className={className} onClick={handleLogoOnClick}>
          <StyledImg src={getImagePath(props)} height={height} alt="Michigan-logo" />
        </div>
      ) : (
        <a href={MICHIGAN_GOV_WEBSITE_URL} className={className}>
          <StyledImg src={getImagePath(props)} height={height} alt="Michigan-logo" />
        </a>
      )}
    </>
  );
};

MichiganLogo.defaultProps = {
  height: 16,
  style: {},
};

export default MichiganLogo;
